export const ipExamples = ['10.0.0.0/8','127.0.0.1','192.168.1.0/24','172.16.0.0/16','2001:db8:85a3:8d3:1319:8a2e:370:7348','2402:9400:1000:6::/64']